import { useTranslation } from 'react-i18next'
import {
  Button,
  IconRocket,
  IconEyeSlash,
  Text,
  IconCheckCircleOutline,
  TooltipRenderer,
  Stack,
  Skeleton,
  IconVisibilityOutline
} from '@machobear/design-system'
import { useListingActions } from '../../../context/listing-actions'
import { useListingData } from '../../../context/listing-data'
import { useListingDashboardModals } from '../../../modals'

export const DetailsButtons = () => {
  const { t } = useTranslation()

  const { listingPending, listingHidden, loading } = useListingData()
  const { markAsRented, hideListing, unhideListing } = useListingActions()
  const { showModal } = useListingDashboardModals()

  if (loading) {
    return (
      <Stack space="xsmall">
        <Skeleton.Button />
        <Skeleton.Button />
        <Skeleton.Button />
      </Stack>
    )
  }

  return (
    <Stack space="xsmall">
      <Button icon={<IconRocket />} onClick={showModal('sponsoredListing')}>
        {t('Boost listing')}
      </Button>

      {listingPending ? (
        <TooltipRenderer
          id="tooltip-disabled-mark-as-rented-button"
          placement="top"
          tooltip={
            <Stack space="xsmall">
              <Text size="standard" weight="strong">
                {t('Your listing is still pending')}
              </Text>
              <Text size="small">{t('To continue, please publish your listing.')}</Text>
            </Stack>
          }
        >
          {({ triggerProps }) => (
            <Button
              disabled
              icon={<IconCheckCircleOutline />}
              onClick={markAsRented}
              variant="ghost"
              {...triggerProps}
            >
              {t('Mark as rented')}
            </Button>
          )}
        </TooltipRenderer>
      ) : (
        <Button icon={<IconCheckCircleOutline />} onClick={markAsRented} variant="ghost">
          {t('Mark as rented')}
        </Button>
      )}

      {listingHidden ? (
        <Button icon={<IconVisibilityOutline />} variant="ghost" onClick={unhideListing}>
          {t('Unhide listing')}
        </Button>
      ) : (
        <Button icon={<IconEyeSlash />} variant="ghost" onClick={hideListing}>
          {t('Hide listing')}
        </Button>
      )}
    </Stack>
  )
}
